define.alias("shared/components/shared/period-time-picker", "media/components/shared/period-time-picker");